export default __webpack_public_path__ + "d00555f1e7b21ed6093f69837abd9a09.png";